import React from 'react'
import { Link } from 'react-router-dom'

function Kubo() {
    return (
        <div>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">KUBO</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newkubo.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">KUBO</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">An urban and contemporary concept.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Designed for excellence food service, KUBO is the display line for modern Coffee Shop and Catering, which combines a contemporary design with accuracy and reliability. The line unfolds in showcases, glass corners, outlet boxes and counters. With an elevated exposition level, KUBO displays give exposed products the leading role in your business. And this means sales!.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <div className="flex flex-col gap-3 md:flex-row justify-center items-center">
         <p className="text-xl lg:text-2xl opacity-90">Pastry, Sandwiches, Cold Dishes and Beverages</p>
         <p className="text-xl font-thin opacity-70"><span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       </div>
       <p className="text-xl lg:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
       <p className="text-xl lg:text-2xl opacity-90">Ice cream<span className='text-fuchsia-950'>-18… -15 °C (4L1) -18… -10 °C</span> <span  className='text-gray-400'>(4G3)</span>  </p>
       <p className="text-xl lg:text-2xl opacity-90">Frozen desserts <span className='text-fuchsia-950'>-18… -10 °C</span> <span  className='text-gray-400'>(4G3)</span>  </p>
       <p className="text-xl lg:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(ventilated, ventilated with humidity control)</span><span className='text-red-500'>+65 °C</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                {/* ✅ Image Wrapper */}
                <div className="w-full md:w-1/2">
                 <img src="/images/kubocase.jpg" className="max-w-full h-auto object-contain" />
               </div>
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Always tempting and delicious bread and cakes!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Fan assisted cooling system which assures an even temperature distribution.",
            "Bread exhibitor with crumb collector.",
            "Versions with humidification system up to 80% RH, which assures an excellent presentation and extends the durability of your Pastry products.",
            "LED lightning of high brightness and high-energy efficiency.",
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">An incredible presentation for irresistible Chocolates!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Fan assisted cooling system with controlled temperature and.",
            "LED lightning of high brightness and high energy efficiency.",
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>
 {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/kubocase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/kubopres.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Fresh salads, grilled meat, rice and pasta, …, the most complete take-away!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Models with cooled cover, heated cover, fan assisted heating, fan assisted heating with humidification, and water bath.",
            "Elevated exposition level in order for all products to be closer to the customer and as such generate more sales.",
            "Fan assisted cooling/heating system which assures an even temperature distribution.",
            "LED lighting of high brightness and high energy efficiency."
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>


                
             </div>
    
           
    
          
         </div>
    
         <div className='mb-12 p-4'>
        <p className='text-2xl'>Choose your style!</p>
        <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "2 front glass options: straight glass with one shelf for neutral exposition (VD) and low straight glass (VUV).",
            "Under request other colours and coating materials inside and outside the equipment may be used.",
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
    </div>
     </div>
    
  
        </div>
      )
    }

export default Kubo